<template>
  <div id="app">

    <router-view />
  </div>
</template>

<script>
fnResize()
window.onresize = function () {
  fnResize()
}
function fnResize () {
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth
  if (deviceWidth >= 750) {
    deviceWidth = 750
  }
  document.documentElement.style.fontSize = (deviceWidth / 10) + 'px'
}
export default {
  name: 'App',
  data () {
    return {

    }
  },
  mounted () {
    var langs='zh-CN';
    if(this.$store.state.lang==undefined){
      
    }else{
      langs=this.$store.state.lang=='en-US'?'en-US':'zh-CN'
    }
    // var langs=this.$store.state.lang=='en-US'?'en-US':'zh-CN'
    this.$store.commit('setlang', langs);
    console.log('lang',langs)
    this.$i18n.locale = langs;
    if (this.$i18n.locale == 'en-US') {
      $('#app').addClass('font_family');
    } else {
      $('#app').addClass('font_family_cn');
    }
  },
  methods: {

  },
}
</script>

<style>

/* @import './common/font/font.css'; */

@import '/assets/font/iconfont.css';
.font_family {
  font-family: 'Microsoft JhengHei', sans-serif;
}
.font_family_cn {
  font-family: AlibabaPuHuiTiR, 'Avenir', Helvetica, Arial, sans-serif,
    MicrosoftYaHei;
}
.font_family_cn .text-align-justify {
  text-align: justify !important;
}
.font_family_cn .p.justify {
  text-align: justify !important;
}
#app {
  /*font-family: "Microsoft JhengHei", sans-serif;*/
  /*font-family: AlibabaPuHuiTiR, "Microsoft JhengHei", sans-serif, 'Avenir', Helvetica, Arial, MicrosoftYaHei;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #3a3a3a;
  margin: 0 0;
  padding: 0 0;
  min-height: 100%;
}
::selection {
  background: #009fe9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue